module.exports = __webpack_public_path__ + "static/img/case-gl-page-bg-06.2bf743c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/gl/case-gl-page-bg-06.jpg
// module id = cjHN
// module chunks = 1